import {
  Environment,
  Language,
  Subsidiary,
  SubsidiaryLanguageMap
} from '@coolblue-development/constants';

const envToBaseUrlMapping: Record<Environment, SubsidiaryLanguageMap<string>> = {
  [Environment.PRODUCTION]: {
    [Subsidiary.BE]: {
      [Language.DUTCH]: 'https://www.coolblue.be/nl',
      [Language.ENGLISH]: 'https://www.coolblue.be/en',
      [Language.FRENCH]: 'https://www.coolblue.be/fr'
    },
    [Subsidiary.DE]: {
      [Language.GERMAN]: 'https://www.coolblue.de',
      [Language.ENGLISH]: 'https://www.coolblue.de/en'
    },
    [Subsidiary.NL]: {
      [Language.DUTCH]: 'https://www.coolblue.nl',
      [Language.ENGLISH]: 'https://www.coolblue.nl/en'
    }
  },
  [Environment.ACCEPTANCE]: {
    [Subsidiary.BE]: {
      [Language.DUTCH]: 'https://www-coolblue-be.accept.zone/nl',
      [Language.ENGLISH]: 'https://www-coolblue-be.accept.zone/en',
      [Language.FRENCH]: 'https://www-coolblue-be.accept.zone/fr'
    },
    [Subsidiary.DE]: {
      [Language.GERMAN]: 'https://www-coolblue-de.accept.zone',
      [Language.ENGLISH]: 'https://www-coolblue-de.accept.zone/en'
    },
    [Subsidiary.NL]: {
      [Language.DUTCH]: 'https://www-coolblue-nl.accept.zone',
      [Language.ENGLISH]: 'https://www-coolblue-nl.accept.zone/en'
    }
  },
  [Environment.CI]: {
    [Subsidiary.BE]: {
      [Language.DUTCH]: 'https://www-coolblue-be.tst.zone/nl',
      [Language.ENGLISH]: 'https://www-coolblue-be.tst.zone/en',
      [Language.FRENCH]: 'https://www-coolblue-be.tst.zone/fr'
    },
    [Subsidiary.DE]: {
      [Language.GERMAN]: 'https://www-coolblue-de.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-de.tst.zone/en'
    },
    [Subsidiary.NL]: {
      [Language.DUTCH]: 'https://www-coolblue-nl.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-nl.tst.zone/en'
    }
  },
  [Environment.TESTING]: {
    [Subsidiary.BE]: {
      [Language.DUTCH]: 'https://www-coolblue-be.tst.zone/nl',
      [Language.ENGLISH]: 'https://www-coolblue-be.tst.zone/en',
      [Language.FRENCH]: 'https://www-coolblue-be.tst.zone/fr'
    },
    [Subsidiary.DE]: {
      [Language.GERMAN]: 'https://www-coolblue-de.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-de.tst.zone/en'
    },
    [Subsidiary.NL]: {
      [Language.DUTCH]: 'https://www-coolblue-nl.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-nl.tst.zone/en'
    }
  },
  [Environment.DEVELOPMENT]: {
    [Subsidiary.BE]: {
      [Language.DUTCH]: 'https://www-coolblue-be.tst.zone/nl',
      [Language.ENGLISH]: 'https://www-coolblue-be.tst.zone/en',
      [Language.FRENCH]: 'https://www-coolblue-be.tst.zone/fr'
    },
    [Subsidiary.DE]: {
      [Language.GERMAN]: 'https://www-coolblue-de.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-de.tst.zone/en'
    },
    [Subsidiary.NL]: {
      [Language.DUTCH]: 'https://www-coolblue-nl.tst.zone',
      [Language.ENGLISH]: 'https://www-coolblue-nl.tst.zone/en'
    }
  }
};

const subsidiaryToLanguageSlugMapping: SubsidiaryLanguageMap<string> = {
  [Subsidiary.BE]: {
    [Language.DUTCH]: '/nl',
    [Language.ENGLISH]: '/en',
    [Language.FRENCH]: '/fr'
  },
  [Subsidiary.DE]: {
    [Language.GERMAN]: '/de',
    [Language.ENGLISH]: '/en'
  },
  [Subsidiary.NL]: {
    [Language.DUTCH]: '/nl',
    [Language.ENGLISH]: '/en'
  }
};

export const generateWebsiteUrl = (
  vacancySlug: string,
  subsidiary: Subsidiary,
  language: Language,
  environment?: Environment
) => {
  const envMapping = environment
    ? envToBaseUrlMapping[environment]
    : subsidiaryToLanguageSlugMapping;
  const subsidiaryMapping = envMapping[subsidiary] as Record<Language, string>;
  const baseUrl = subsidiaryMapping[language];
  const path = (() => {
    switch (language) {
      case Language.DUTCH:
        return 'vacatures';
      case Language.ENGLISH:
        return 'vacancies';
      case Language.GERMAN:
        return 'jobs';
      case Language.FRENCH:
        return 'emplois';
      default:
        return 'vacatures';
    }
  })();

  return `${baseUrl}/${path}/${vacancySlug}`;
};
